import React, { useEffect, useState } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import img1 from "../assets/img/favicon.png";
import "../assets/css/video-js.css";
import ReactPlayer from "react-player";

const Tour = (props) => {
  const [link, setLink] = useState(
    "https://rbiretaildirect.org.in/common/videos/Introduction.mp4"
  );
  let data = [
    {
      // url: "https://pmindiawebcast.nic.in/player/vod/pmevents/media/pm12nov21.mp4",
      url: "https://rbiretaildirect.org.in/common/videos/PMO-RD-Launch.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "ആർ.ബി.ഐ. റീട്ടെയിൽ ഡയറക്ട്",
      title: "ബഹുമാനപ്പെട്ട ഇന്ത്യൻ പ്രധാനമന്ത്രി ഉദ്ഘാടനം ചെയ്യുന്നു",
      length: "",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Introduction.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "",
      title: "ആമുഖം",
      length: "",
      playing: true,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Bond Basics.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "ബോണ്ട് അടിസ്ഥാനങ്ങൾ",
      title: "ബോണ്ട് അടിസ്ഥാനങ്ങൾ",
      length: "0:15",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Types of G-Secs.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ജി-സെക് തരങ്ങൾ",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Factors Affecting G-Sec Prices.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ജി-സെക് വിലകളെ ബാധിക്കുന്ന ഘടകങ്ങൾ",
      length: "0:15",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/G-Sec Returns.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "G-Sec Returns",
    //   length: "10:53",
    //   playing: false,
    // },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Price Yield Relationship.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Price Yield Relationship",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "G-സെക് വിലനിർണ്ണയം - ഭാഗം 1",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs-2.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "G-സെക് വിലനിർണ്ണയം - ഭാഗം 2",
      length: "10:53",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Risks on G-Secs.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Risks on G-Secs",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Concept of interest rates.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "പലിശ നിരക്കുകളുടെ ആശയം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/Yield Curves.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "യീൽഡ് കർവുകൾ",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to do KYC.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "പ്രൈമറി മാർക്കറ്റ്",
      title: "കെ.വൈ.സി. എങ്ങനെ ചെയ്യാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to login to account.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "എങ്ങനെ ലോഗിൻ ചെയ്യാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to bid.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "എങ്ങനെ ബിഡ് ചെയ്യാം",
      length: "0:15",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to fund a bid.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ബിഡ് എങ്ങനെ ഫണ്ട് ചെയ്യാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to amend a bid.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ബിഡ് എങ്ങനെ ഭേദഗതി ചെയ്യാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to withdraw a bid.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "ബിഡ് എങ്ങനെ പിൻവലിക്കാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to view allotment.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "അലോട്ട്മെന്‍റ് എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to view holdings.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ഹോൾഡിംഗ്സ് എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to view recent auctions.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "സമീപകാല ലേലങ്ങൾ എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to check coupon data.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "കൂപ്പൺ ഡാറ്റ എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to view redemptions.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "റിഡീംഷനുകൾ എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to view transaction history.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ഇടപാട് ചരിത്രം എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/How to check fund activity log.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ഫണ്ടുകളുടെ പ്രവർത്തന ലോഗ് എങ്ങനെ കാണും",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/sec-nds-om-access-request.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "സെക്കൻഡറി മാർക്കറ്റ്",
      title: "എൻ.ഡി.എസ്. ഒ.എം.-നായി എങ്ങനെ രജിസ്റ്റർ ചെയ്യാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/sec-add-mw.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "നിങ്ങളുടെ മാർക്കറ്റ് വാച്ച് എങ്ങനെ സജ്ജീകരിക്കാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/sec-order.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ഒരു ഓർഡർ എങ്ങനെ നൽകാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/sec-rfq.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "ഒരു ആർ.എഫ്‌.ക്യു. നിരക്കുവില എങ്ങനെ നൽകാം",
      length: "10:53",
      playing: false,
    },
    {
      url: "https://rbiretaildirect.org.in/common/videos/sec-ytm.mp4",
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "വൈ.ടി.എം. കാൽക്കുലേറ്റർ എങ്ങനെ ഉപയോഗിക്കാം ",
      length: "10:53",
      playing: false,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let last_video_index = 0;

  const changeVideo = (s) => {
    if (s.url) {
      data[last_video_index].playing = false;
      last_video_index = data.indexOf(s);
      data[last_video_index].playing = true;
      setLink(s.url);
    }
  };

  return (
    <div>
      <NavBar />
      <main id="main">
        <section id="tour" className="innerPage">
          <div className="container">
            <div className="section-title">
              <h2>ഗൈഡഡ് ടൂർ</h2>
            </div>

            <div className="row page-wrapper">
              <div className="col-lg-8">
                <div className="playlist-wrapper">
                  <div className="playlist-mother-video">
                    <ReactPlayer
                      url={link}
                      muted={false}
                      playing={true}
                      controls={true}
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                      style={{ maxWidth: "100%" }}
                    />
                  </div>
                  <div className="playlist-products"></div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="playlist-child-videos" id="plylst_upcming">
                  {data &&
                    data.map((data, index) => (
                      <div
                        className="playlist-item-wrapper"
                        data-playing={data.playing.toString()}
                        data-live={data.isLive.toString()}
                        onClick={() => changeVideo(data)}
                      >
                        <div
                          className="playlist-thumb"
                          style={{ display: "none" }}
                        >
                          <img src={data.thumbnail} />
                          <div className="playlist-meta-length">
                            <span>{data.isLive ? "Live" : data.length}</span>
                          </div>
                        </div>
                        <div className="playlist-meta">
                          <h5 className="playlist-meta-header">
                            {data.header}
                          </h5>
                          <a className="playlist-meta-title">
                            <i className="ri-video-line"></i>
                            {data.title}
                          </a>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
  );
};

export default Tour;
